<template>
  <el-card style="margin-top: 30px">

    <h3 style="margin-bottom: 5px; margin-top: 0">Данные процедуры</h3>

    <el-table
      size="mini"
      :data="procedureUsers"
      v-loading="loading"
    >
      <el-table-column label="Компенсационный менеджер работника" prop="chief.full_name"></el-table-column>
      <el-table-column label="ФИО сотрудника" prop="full_name"></el-table-column>
      <el-table-column label="Должность" prop="position"></el-table-column>
      <el-table-column label="Личный номер сотрудника" prop="persnum"></el-table-column>
      <el-table-column label="Месяц" prop="month"></el-table-column>
      <el-table-column label="Оклад" prop="salary" v-slot="scope">
        <click-to-edit
          v-model="scope.row.salary"
          :disabled="!scope.row.month_index"
          :number-format="{decimals: 2, space:true}"
          placeholder=""
          digits-only
          @input="saveProcedureUserProp('salary', scope.row)"
        ></click-to-edit>
      </el-table-column>
      <el-table-column label="Целевой % годового бонуса" prop="year_bonus_percent"v-slot="scope">
        <click-to-edit
          v-model="scope.row.year_bonus_percent"
          :disabled="!scope.row.month_index"
          :number-format="{decimals: 2, space:true}"
          placeholder=""
          digits-only
          @input="saveProcedureUserProp('year_bonus_percent', scope.row)"
        ></click-to-edit>
      </el-table-column>
      <el-table-column label="Целевой размер годового бонуса" prop="year_bonus_value"></el-table-column>
      <el-table-column label="Взвешенный коэффициент выполнения КПЭ" prop="card_weight_fact" v-slot="scope">
        <click-to-edit
          v-model="scope.row.card_weight_fact"
          :disabled="!scope.row.month_index"
          :number-format="{decimals: 2, space:true}"
          placeholder=""
          digits-only
          @input="saveProcedureUserProp('card_weight_fact', scope.row)"
        ></click-to-edit>
      </el-table-column>
      <el-table-column label="Годовой бонус к выплате" prop="total_year_bonus" v-slot="scope">
        <click-to-edit
          v-model="scope.row.total_year_bonus"
          :disabled="!scope.row.month_index"
          :number-format="{decimals: 2, space:true}"
          placeholder=""
          digits-only
          @input="saveProcedureUserProp('total_year_bonus', scope.row)"
        ></click-to-edit>
      </el-table-column>
      <el-table-column width="54" v-slot="scope">
        <el-popconfirm
          confirm-button-text='Да'
          cancel-button-text='нет'
          icon="el-icon-question"
          title="Вы уверены, что хотите удалить пользователя?"
          @confirm="deleteProcedureUser(scope.row)"
        >
          <el-button
            style="margin-right: 10px"
            slot="reference"
            class="table-action-button"
            type="default"
            round
            size="mini"
            icon="far fa-trash-alt"
          >
          </el-button>
        </el-popconfirm>
      </el-table-column>
    </el-table>

    <paginator
      :paginator.sync="paginator"
      @page-changed="getProcedureUsers"
    ></paginator>


  </el-card>
</template>

<script>

import requestSender from "@/api/base/requestSender";
import ClickToEdit from "@/components/ClickToEdit.vue";
import {ProcedureEditMixin} from "@/componentsCompany/smz/compensation/mixins/ProcedureEditMixin";
import { paginator } from "@/mixins/paginator";
import Paginator from "@/components/Paginator.vue";

export default {
  name: "YearBonusTemplate",
  components: { Paginator, ClickToEdit},
  mixins: [ProcedureEditMixin, paginator],
  props: {
    procedure: {type: Object, required: true},
  },

  data() {

    return {
      loading: false,

      procedureUsers: [],

    }
  },

  mounted() {
    this.getProcedureUsers();
  },
  methods: {

    getProcedureUsers(){
      this.loading = true;
      requestSender('get', 'compensation-procedure-year-bonus/get-procedure-users-data', {
        procedure_id: this.procedure.id,
        ...this.filters,

        // [this.sorter.param]: this.sorter.sort,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator, sorter}) => {
          this.procedureUsers = data.procedure_users;
          this.paginatorFill(paginator);
          // this.sorterFill(sorter);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveProcedureUserProp(prop, procedureUserData){
      this.loading = true;
      requestSender('post', 'compensation-procedure-year-bonus/save-procedure-user-prop', {
        procedure_id: this.procedure.id,
        user_id: procedureUserData.user_id,
        month_index: procedureUserData.month_index,
        prop: prop,
        value: +procedureUserData[prop],
      })
        .finally(() => {
          this.getProcedureUsers();
        });
    },

    deleteProcedureUser(procedureUser){
      this.loading = true;
      requestSender('post', 'compensation-procedure-year-bonus/delete-procedure-users', {
        procedure_id: this.procedure.id,
        user_ids: [procedureUser.user_id],
      })
        .finally(() => {
          this.getProcedureUsers();
        });
    },

  },


}
</script>

<style lang="scss">

</style>